import React from 'react'
import { string } from 'prop-types'
import { connect } from 'react-redux'
import { Div, P } from '../styles/AddressContainer'

const AddressContainer = ({ address, color }) => (
  <Div theme={color}>
    <P theme={color}>{address}</P>
  </Div>
)

AddressContainer.propTypes = {
  address: string.isRequired,
  color: string.isRequired,
}

const mapStateToProps = ({ signsState, map, spi }) => ({
  address: signsState.address,
  color: spi.theme,
})

export default connect(mapStateToProps)(AddressContainer)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/AddressContainer/index.jsx